import { enderecoStep, enderecoComercialStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL, DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { converterEtnia, DEFICIENCIA_OPCOES, DEFICIENCIA_NAO_POSSUI_ID } from '../../shared/catalogosPessoaFisica';

// Converte true/false pro texto que a API de Protocolo espera em
// POST /requerimento/:id/dados pros campos de declaração (confirmado com o
// usuário: "True"/"False" capitalizado, diferente do "S"/"N" do PUT /pessoa/:id).
const paraTextoBooleano = (v) => (v ? 'True' : 'False');

const pedidoAtualizacaoCadastralConfig = {
  id: 'pedido_atualizacao_cadastral',
  nome: 'Atualização Cadastral',
  descricao: 'Atualize etnia, deficiência, endereço e preferências de divulgação de dados junto à OAB/MS',
  // PJ também acessa este pedido, sem os campos marcados com `apenasPF`
  // (Etnia, Deficiência, AASP) e com a etapa de endereço trocada pela `versaoPJ`
  // (só Endereço Comercial) — ver adaptarConfigAoPerfil em acessoPedidoService.
  descricaoPJ: 'Atualize endereço e preferências de divulgação de dados junto à OAB/MS',
  icon: 'FaIdCard',

  documentConfig: {
    required: []
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '220',
    tiposAssunto: '427',
    tipoPedido: '465'
  },

  // IDs de campo (modeloRequerimentoCampoId) informados diretamente pelo usuário
  // pra este modeloRequerimento (220) — não resolvidos por campoNome via GET
  // /modelo-requerimento/220/campos, ao contrário do restante do módulo, porque
  // são campos novos sem nome confirmado ainda (ver dadosRequerimentoService.js).
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'etnia', modeloRequerimentoCampoId: 166, convert: converterEtnia },
        { field: 'possuiDeficiencia', modeloRequerimentoCampoId: 167 },
        { field: 'concordaDivulgacaoListagens', modeloRequerimentoCampoId: 164, convert: paraTextoBooleano },
        { field: 'cadastrarNaAASP', modeloRequerimentoCampoId: 577, convert: paraTextoBooleano }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL,
    DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL
  ),

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Declarações pessoais',
          fields: [
            {
              type: 'select',
              name: 'etnia',
              label: 'Etnia (auto-declaração)',
              required: true,
              apenasPF: true,
              options: [
                { value: 'Branca', label: 'Branca' },
                { value: 'Negra', label: 'Negra' },
                { value: 'Parda', label: 'Parda' },
                { value: 'Indigena', label: 'Indígena' },
                { value: 'Amarela', label: 'Amarela' },
                { value: 'NaoInformado', label: 'Não informado' }
              ]
            },
            {
              type: 'select',
              name: 'possuiDeficiencia',
              label: 'Deficiência',
              required: true,
              apenasPF: true,
              options: DEFICIENCIA_OPCOES,
              defaultValue: DEFICIENCIA_NAO_POSSUI_ID
            }
          ]
        }
      ]
    },
    {
      ...enderecoStep({ comProfissional: true, autoCep: true }),
      // PJ não tem endereço residencial, "está em seu nome?" nem correspondência:
      // só o Endereço Comercial, obrigatório.
      versaoPJ: enderecoComercialStep({ autoCep: true })
    },
    {
      id: 'divulgacao_dados',
      title: 'Divulgação de Dados',
      sections: [
        {
          title: 'Divulgação de Dados',
          fields: [
            {
              type: 'checkbox',
              name: 'concordaDivulgacaoListagens',
              label: 'CASO MARQUE O CAMPO ABAIXO, CONCORDA EM TER SEUS DADOS DIVULGADOS PELA OABMS (apenas dados de caráter "Comercial"). Concorda com a divulgação de seus dados em listagens?',
              clearFieldsOnUncheck: ['cadastrarNaAASP']
            },
            {
              type: 'checkbox',
              name: 'cadastrarNaAASP',
              label: 'Cadastrar-me também na AASP',
              apenasPF: true,
              showWhen: { field: 'concordaDivulgacaoListagens', value: true }
            }
          ]
        }
      ]
    },
    termosStep([])
  ]
};

export default pedidoAtualizacaoCadastralConfig;
